import React, { Component } from "react";
import "./RiskDisclosure.css"
import i18n from "i18next";

export default class RiskDisclosure extends Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  componentWillReceiveProps(nextProps: any) {
    if (nextProps.lang !== this.props.lang) {
      this.props.history.push(
        "/riskDisclosure?lang=" + nextProps.lang + "&cc=" + nextProps.cc
      );
    }
  }

  render() {
    return (
      <div
        className="Disclaimer-Modal"
        style={{ fontSize: this.props.fontSize || "100%" }}
      >
        <div className="Modal-title">{i18n.t("Common.DisclaimerLink")}</div>
        <div className="content"
          dangerouslySetInnerHTML={{
            __html: i18n.t("Common.Disclaimer.Content1"),
          }}
        ></div>
      </div>
    );
  }
}
